import { render, staticRenderFns } from "./gc-menu-cell-template.vue?vue&type=template&id=af4a92c8"
import script from "./gc-menu-cell-template.vue?vue&type=script&lang=js"
export * from "./gc-menu-cell-template.vue?vue&type=script&lang=js"
import style0 from "./gc-menu-cell-template.vue?vue&type=style&index=0&id=af4a92c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports